export default {
  "ELDEON/EJ01": [
    [
      31,
      41
    ],
    [
      31,
      37
    ]
  ],
  "ELDEON/EJ02": [
    [
      31,
      38
    ],
    [
      31,
      39
    ]
  ],
  "ELDEON/EJ03": [
    [
      31,
      35
    ],
    [
      31,
      34
    ]
  ],
  "ELDEON/EJ04": [
    [
      31,
      38
    ],
    [
      31,
      40
    ]
  ],
  "ELDEON/EJT01": [
    [
      31,
      36
    ],
    [
      31,
      37
    ]
  ],
  "ELDEON/EZ01": [
    [
      31,
      35
    ],
    [
      31,
      34
    ]
  ],
  "ELDEON/TITLE": [
    [
      31,
      32
    ],
    [
      31,
      33
    ]
  ],
  "JUNON/AGIT01": [
    [
      32,
      32
    ],
    [
      32,
      32
    ]
  ],
  "JUNON/AGIT02": [
    [
      32,
      32
    ],
    [
      32,
      32
    ]
  ],
  "JUNON/AGIT03": [
    [
      32,
      32
    ],
    [
      32,
      32
    ]
  ],
  "JUNON/AGIT04": [
    [
      32,
      32
    ],
    [
      32,
      32
    ]
  ],
  "JUNON/CD01": [
    [
      31,
      33
    ],
    [
      28,
      34
    ]
  ],
  "JUNON/JB01": [
    [
      31,
      33
    ],
    [
      31,
      33
    ]
  ],
  "JUNON/JD01": [
    [
      31,
      34
    ],
    [
      30,
      33
    ]
  ],
  "JUNON/JD02": [
    [
      31,
      35
    ],
    [
      30,
      34
    ]
  ],
  "JUNON/JD03": [
    [
      31,
      36
    ],
    [
      30,
      35
    ]
  ],
  "JUNON/JD04": [
    [
      31,
      36
    ],
    [
      31,
      34
    ]
  ],
  "JUNON/JDT01": [
    [
      31,
      34
    ],
    [
      30,
      33
    ]
  ],
  "JUNON/JG01": [
    [
      31,
      37
    ],
    [
      30,
      33
    ]
  ],
  "JUNON/JG02": [
    [
      31,
      34
    ],
    [
      30,
      34
    ]
  ],
  "JUNON/JG03": [
    [
      31,
      35
    ],
    [
      30,
      34
    ]
  ],
  "JUNON/JG04": [
    [
      31,
      35
    ],
    [
      30,
      34
    ]
  ],
  "JUNON/JG05": [
    [
      31,
      36
    ],
    [
      30,
      34
    ]
  ],
  "JUNON/JG06": [
    [
      31,
      36
    ],
    [
      30,
      34
    ]
  ],
  "JUNON/JG07": [
    [
      30,
      36
    ],
    [
      30,
      36
    ]
  ],
  "JUNON/JG08": [
    [
      29,
      35
    ],
    [
      29,
      35
    ]
  ],
  "JUNON/JG09": [
    [
      29,
      35
    ],
    [
      29,
      35
    ]
  ],
  "JUNON/JG10": [
    [
      29,
      35
    ],
    [
      29,
      35
    ]
  ],
  "JUNON/JGT01": [
    [
      31,
      37
    ],
    [
      30,
      33
    ]
  ],
  "JUNON/JMOV01": [
    [
      32,
      32
    ],
    [
      32,
      32
    ]
  ],
  "JUNON/JPT01": [
    [
      30,
      37
    ],
    [
      30,
      35
    ]
  ],
  "JUNON/JPVP01": [
    [
      31,
      33
    ],
    [
      30,
      33
    ]
  ],
  "JUNON/JPVP02": [
    [
      31,
      33
    ],
    [
      30,
      33
    ]
  ],
  "JUNON/JPVP04": [
    [
      31,
      34
    ],
    [
      31,
      36
    ]
  ],
  "JUNON/JPVP05": [
    [
      30,
      34
    ],
    [
      30,
      35
    ]
  ],
  "JUNON/JZ01_1": [
    [
      31,
      34
    ],
    [
      30,
      33
    ]
  ],
  "JUNON/JZ01_2": [
    [
      31,
      34
    ],
    [
      30,
      33
    ]
  ],
  "JUNON/JZ01_3": [
    [
      31,
      35
    ],
    [
      30,
      34
    ]
  ],
  "JUNON/JZC01": [
    [
      31,
      33
    ],
    [
      31,
      33
    ]
  ],
  "JUNON/JZP01": [
    [
      31,
      32
    ],
    [
      31,
      32
    ]
  ],
  "JUNON/JZP02": [
    [
      31,
      35
    ],
    [
      31,
      34
    ]
  ],
  "JUNON/JZP03": [
    [
      31,
      34
    ],
    [
      31,
      34
    ]
  ],
  "JUNON/JZP04": [
    [
      31,
      34
    ],
    [
      31,
      34
    ]
  ],
  "JUNON/JZPI01": [
    [
      31,
      34
    ],
    [
      31,
      34
    ]
  ],
  "JUNON/JZP_PVP01": [
    [
      32,
      34
    ],
    [
      31,
      33
    ]
  ],
  "JUNON/MUDOJANG": [
    [
      32,
      32
    ],
    [
      32,
      32
    ]
  ],
  "JUNON/SUM_EVENT": [
    [
      31,
      33
    ],
    [
      31,
      33
    ]
  ],
  "JUNON/TITLE_JG01": [
    [
      35,
      36
    ],
    [
      32,
      33
    ]
  ],
  "JUNON/TITLE_JPT": [
    [
      32,
      32
    ],
    [
      31,
      32
    ]
  ],
  "LUNAR/LGDP01": [
    [
      30,
      34
    ],
    [
      30,
      33
    ]
  ],
  "LUNAR/LMT01": [
    [
      31,
      35
    ],
    [
      31,
      35
    ]
  ],
  "LUNAR/LP01": [
    [
      31,
      38
    ],
    [
      31,
      38
    ]
  ],
  "LUNAR/LP02": [
    [
      31,
      40
    ],
    [
      31,
      36
    ]
  ],
  "LUNAR/LP03": [
    [
      31,
      36
    ],
    [
      30,
      39
    ]
  ],
  "LUNAR/LP04": [
    [
      31,
      36
    ],
    [
      31,
      37
    ]
  ],
  "LUNAR/LP05": [
    [
      31,
      38
    ],
    [
      31,
      38
    ]
  ],
  "LUNAR/LPVP01": [
    [
      31,
      34
    ],
    [
      31,
      34
    ]
  ],
  "LUNAR/LPVP05": [
    [
      31,
      32
    ],
    [
      31,
      33
    ]
  ],
  "LUNAR/LSF01": [
    [
      31,
      33
    ],
    [
      31,
      33
    ]
  ],
  "LUNAR/LSOD01": [
    [
      30,
      34
    ],
    [
      31,
      36
    ]
  ],
  "LUNAR/LZ01": [
    [
      31,
      35
    ],
    [
      31,
      39
    ]
  ],
  "LUNAR/LZ02": [
    [
      31,
      36
    ],
    [
      31,
      34
    ]
  ],
  "LUNAR/WIN_EVENT": [
    [
      31,
      32
    ],
    [
      31,
      32
    ]
  ],
  "ORO/ODC01": [
    [
      30,
      33
    ],
    [
      31,
      34
    ]
  ],
  "ORO/ODD01": [
    [
      31,
      34
    ],
    [
      31,
      35
    ]
  ],
  "ORO/ODD02": [
    [
      31,
      34
    ],
    [
      31,
      35
    ]
  ],
  "ORO/ODD03": [
    [
      30,
      34
    ],
    [
      31,
      34
    ]
  ],
  "ORO/ODD04": [
    [
      31,
      35
    ],
    [
      31,
      33
    ]
  ],
  "ORO/ODD05": [
    [
      31,
      35
    ],
    [
      31,
      33
    ]
  ],
  "ORO/ODE01": [
    [
      31,
      33
    ],
    [
      31,
      32
    ]
  ],
  "ORO/ODOS01": [
    [
      31,
      32
    ],
    [
      31,
      32
    ]
  ],
  "ORO/ODP01": [
    [
      30,
      33
    ],
    [
      31,
      33
    ]
  ],
  "ORO/ODRP01": [
    [
      30,
      34
    ],
    [
      31,
      34
    ]
  ],
  "ORO/OROIP": [
    [
      31,
      32
    ],
    [
      31,
      32
    ]
  ],
  "ORO/TOWN": [
    [
      31,
      33
    ],
    [
      30,
      36
    ]
  ]
};
